import { render, staticRenderFns } from "./ModalPolicyIssuanceGrz.vue?vue&type=template&id=00a7db0d"
import script from "./ModalPolicyIssuanceGrz.vue?vue&type=script&lang=js"
export * from "./ModalPolicyIssuanceGrz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports